import { useEffect } from 'react';
import { readConsent } from '../utils/cookieUtils';
import { initAnalytics } from '../utils/analytics';

// Loads the Google tag + LinkedIn Insight tag for visitors who accepted
// cookies on an earlier visit. A first-time visitor gets the same tags from
// CookieConsent.handleAccept the moment they accept (see initAnalytics), so
// there is exactly one consent gate for all tags, mirroring MatomoTracker.
// readConsent() is null for an outdated consent version, which deliberately
// reads as "no decision" - those tags stay off until the banner is answered.
const AnalyticsTracker = () => {
  useEffect(() => {
    if (readConsent()?.accepted) {
      initAnalytics();
    }
  }, []);

  return null;
};

export default AnalyticsTracker;
